import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NonNullableFormBuilder, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { debounceTime, filter, map, takeUntil } from 'rxjs/operators';
import { noop, Subject } from 'rxjs';
import {
  AssignmentCustomerResponse,
  BASE_CUSTOMER_OFFER_STATUS_OPTIONS,
  baseAssignmentsActions,
  baseAssignmentsSelectors,
  BaseAvatarSize,
  BaseButtonSize,
  BaseCoreState,
  BaseFilterService,
  baseInquiryActions,
  BaseInquiryOffersFilters,
  baseInquirySelectors,
  BaseInquiryService,
  BaseInquiryStatus,
  BaseModalHeaderSizes,
  BaseModalService,
  BaseOfferStatus,
  BaseQueryParamService,
  BaseRolesService,
  InquiryOffersPagination,
  InquiryResponse,
  MetaPagination,
  CustomerInquiryOfferListItemResponse,
  CustomerInquiryOfferProfileListItemResponse,
  OffersCountResponse,
  PspBranchFilterInfoResponse,
  QualificationShortInfoResponse,
  RequirementCategoryResponse,
  RequirementResponse,
  BASE_PERMISSIONS,
  ContractResponse,
  BaseShiftIconsEnum,
  BaseCustomerInquiryOfferInterface,
  InquiryDateResponse,
  ShiftTimeResponse,
  ShiftTimeAndFlexResponse,
  CustomerOfferListItemResponse,
  IndustrySurchargeResponse,
  BaseHelpersService,
  BaseInquiryShiftService,
  OfferPspBranchShortInfoResponse,
} from 'base';
import { BaseCustomerOfferActions } from '../../_enums/base-customer-offer-actions.enum';
import { BaseCustomerInquiryExperienceOptionsConst } from '../../_const/base-customer-inquiry-offers-filters-options.const';
import { BaseCustomerInquiryService } from '../../inquiry.service';
import { BaseCustomerWorkCouncilStatusEnum } from '../../../../shared/_enums/base-customer-work-council-status.enum';
import { BaseCustomerLocationWorkCouncilSettingsInterface } from '../../../../shared/_interfaces/base-customer-location-work-council-settings.interface';
import { BASE_CUSTOMER_WORK_COUNCIL_APPROVAL_OPTIONS } from '../../../offers/_enums/base-customer-offers.enum';

@Component({
  selector: 'base-customer-inquiry-unlimited-offers',
  templateUrl: './base-customer-inquiry-unlimited-offers.component.html',
})
export class BaseCustomerInquiryUnlimitedOffersComponent implements OnInit, OnDestroy {
  @ViewChild('requirementsPopup', { static: true }) requirementsPopup: ElementRef;
  @ViewChild('offerInfoPopup', { static: true }) offerInfoPopup: ElementRef;
  @ViewChild('staffRequest', { static: true }) staffRequest: ElementRef;
  @ViewChild('closeInquiryModal', { static: true }) closeInquiryModal: ElementRef;
  @ViewChild('rejectOfferTemplate') rejectOfferTemplate: ElementRef;
  @ViewChild('datePickerModal') datePickerModal: ElementRef;
  @ViewChild('industrySurchargesModal', { static: true }) industrySurchargesModal: ElementRef;
  offers: BaseCustomerInquiryOfferInterface[] = [];
  filteredOffers: BaseCustomerInquiryOfferInterface[] = [];
  inquiry: Partial<InquiryResponse> = {};
  shiftTimes: (ShiftTimeResponse & { index: number; label?: string })[] = [];
  shiftTimesWithFlex: (ShiftTimeAndFlexResponse & { index: number; label?: string })[] = [];
  offersCount: OffersCountResponse;
  offerProfileRequirements: RequirementResponse[];
  isSidebarVisible = false;
  modalRef: NgbModalRef;
  currentOfferInfo: CustomerInquiryOfferListItemResponse & { order?: number };
  offerAction: BaseCustomerOfferActions;
  assignmentInfo: AssignmentCustomerResponse;
  toOperationTab = false;
  hasAdminAssignmentsPermission: boolean;
  canAcceptOffers: boolean;
  copiedInquiry: InquiryResponse & { id?: number } = {};
  canPublishInquiry: boolean;
  inquiryListActiveFilters: { [key in any]: any } = {};
  pagination: MetaPagination;
  branches: PspBranchFilterInfoResponse[] = [];
  mainQualifications: QualificationShortInfoResponse[] = [];
  hasFiltersValues = false;
  baseOfferStatusOption = BASE_CUSTOMER_OFFER_STATUS_OPTIONS;
  baseCustomerWCApprovalOptions = BASE_CUSTOMER_WORK_COUNCIL_APPROVAL_OPTIONS;
  filtersForm = this.fb.group({
    [BaseInquiryOffersFilters.status]: undefined,
    [BaseInquiryOffersFilters.workCouncilStatus]: undefined,
    [BaseInquiryOffersFilters.rating]: 0,
    [BaseInquiryOffersFilters.experience]: undefined,
    [BaseInquiryOffersFilters.pspBranches]: [[] as number[]],
    [BaseInquiryOffersFilters.mainQualifications]: [[] as number[]],
    [BaseInquiryOffersFilters.search]: [''],
  });
  baseInquiryExperienceOption = BaseCustomerInquiryExperienceOptionsConst;
  validContract: ContractResponse;
  rejectOfferForm = this.fb.group({
    decliningCategory: ['', Validators.required],
    decliningNote: [''],
  });
  modalOptions = [
    { label: 'price.singular', id: 'price' },
    { label: 'candidates.experience', id: 'experience' },
    { label: 'qualifications.singular', id: 'qualification' },
    { label: 'candidates.negativeExperience', id: 'negativeExperience' },
    { label: 'work.miscellaneous', id: 'other' },
  ];
  inquiryWeekdays: {
    mo: boolean;
    tu: boolean;
    we: boolean;
    th: boolean;
    fr: boolean;
    sa: boolean;
    su: boolean;
  };
  clickedIndustrySurchargeIndex: number;

  offersLoaded: boolean;
  isRejectFormSubmitted = false;
  profileName: string;
  isOfferPreselectionAllowed: boolean;
  locationWorkCouncilSettings: BaseCustomerLocationWorkCouncilSettingsInterface;

  baseInquiryStatus = BaseInquiryStatus;
  offerStatuses = BaseOfferStatus;
  offerWorkCouncilStatuses = BaseCustomerWorkCouncilStatusEnum;
  avatarSize = BaseAvatarSize;
  buttonSizes = BaseButtonSize;
  baseShiftIconsEnum = BaseShiftIconsEnum;
  onInquiryCloseModalRef: NgbModalRef;

  private destroy$ = new Subject();

  constructor(
    private store: Store<BaseCoreState>,
    private modalService: BaseModalService,
    private rolesService: BaseRolesService,
    public baseInquiryService: BaseInquiryService,
    private router: Router,
    private queryParamsService: BaseQueryParamService,
    public filterService: BaseFilterService,
    private fb: NonNullableFormBuilder,
    public baseCustomerInquiryService: BaseCustomerInquiryService,
    public activatedRoute: ActivatedRoute,
    private baseInquiryShiftService: BaseInquiryShiftService
  ) {}

  ngOnInit() {
    this.getInquiryActiveFilters();
    this.fetchFilteredInquiries();

    this.isOfferPreselectionAllowed =
      this.rolesService.hasAdminRole() ||
      this.rolesService.hasCustomerFeaturePermission(BASE_PERMISSIONS.FEATURE_PRESELECT_OFFERS);

    this.canPublishInquiry = this.rolesService.hasCustomerFeaturePermission(BASE_PERMISSIONS.FEATURE_PUBLISH_INQUIRY);

    this.hasAdminAssignmentsPermission = this.rolesService.hasCustomerFeaturePermission(
      BASE_PERMISSIONS.FEATURE_ADMIN_ASSIGNMENTS
    );

    this.canAcceptOffers = this.rolesService.hasCustomerFeaturePermission(BASE_PERMISSIONS.FEATURE_ACCEPT_OFFER);

    this.store
      .select(baseInquirySelectors.getCustomerInquiryOffers)
      .pipe(
        takeUntil(this.destroy$),
        filter((response) => response.ok !== undefined)
      )
      .subscribe((offers) => {
        this.mainQualifications = offers.filters?.mainQualifications || [];
        this.branches = offers.filters?.branches || [];
        this.offersLoaded = true;

        this.offers = offers.data;
        this.filteredOffers = this.offers;
        this.offersCount = {
          confirmed: this.offers.filter((offer) => offer.data.status === BaseOfferStatus.confirmed).length,
          needsConfirmation: this.offers.filter((offer) => offer.data.status === BaseOfferStatus.needsConfirmation)
            .length,
          declined: this.offers.filter((offer) => offer.data.status === BaseOfferStatus.declined).length,
          open: this.offers.filter((offer) => offer.data.status === BaseOfferStatus.open).length,
        };
        this.pagination = offers.pagination as MetaPagination;
      });

    this.store
      .select(baseInquirySelectors.getCustomerInquiry)
      .pipe(
        takeUntil(this.destroy$),
        filter((state) => !!state.ok),
        map((response) => response.data as InquiryResponse)
      )
      .subscribe((inquiry) => {
        this.inquiry = inquiry;
        this.shiftTimes = [];
        this.inquiryWeekdays = this.baseInquiryService.getInquiryWeekdays(this.inquiry.dates as InquiryDateResponse[]);
        this.copiedInquiry = { ...this.inquiry, id: inquiry.id };

        if (this.inquiry.shiftTimes?.length) {
          this.shiftTimes = this.baseInquiryShiftService.addIndexAndLabelToShiftTimes(this.inquiry.shiftTimes);
          this.shiftTimes = this.baseInquiryShiftService.sortShiftTimes(this.shiftTimes);
        }
        this.shiftTimesWithFlex = this.baseInquiryShiftService.addFlexShiftToShiftTimes(this.shiftTimes);
        this.locationWorkCouncilSettings = {
          workCouncilActivated: !!this.inquiry.customerLocation?.workCouncilActivated,
          acceptOfferAfterPreselection: !!this.inquiry.customerLocation?.acceptOfferAfterPreselection,
          acceptOfferAfterWorkCouncilApproval: !!this.inquiry.customerLocation?.acceptOfferAfterWorkCouncilApproval,
        };
      });

    this.store
      .select(baseAssignmentsSelectors.getAssignment)
      .pipe(takeUntil(this.destroy$))
      .subscribe((assignment) => {
        this.assignmentInfo = assignment?.data;
        this.validContract = this.assignmentInfo?.contracts?.find((contract) => contract.valid) as ContractResponse;
      });

    this.initFilterValuesByQueryParams();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.store.dispatch(baseInquiryActions.clearOfferManagementPage());
  }

  onSearchChange(query: string): void {
    this.filtersForm.controls[BaseInquiryOffersFilters.search].setValue(query);
    this.queryParamsService.filterSubject.next({
      page: this.activatedRoute.snapshot.queryParams.page,
      filters: this.filtersForm.value,
    });
  }

  toggleSidebar(): void {
    this.isSidebarVisible = !this.isSidebarVisible;
  }

  acceptOrRejectOfferFromInfoModal(event: BaseCustomerOfferActions): void {
    this.offerAction = event;
  }

  openOfferInfoModal(
    offer: CustomerInquiryOfferListItemResponse & { order?: number },
    toOperation: boolean = false,
    event?: Event
  ): void {
    event?.stopPropagation();
    this.toOperationTab = toOperation;
    this.currentOfferInfo = offer;
    if (offer.assignment && offer.status === this.offerStatuses.confirmed && this.hasAdminAssignmentsPermission) {
      this.store.dispatch(baseAssignmentsActions.loadAssignment({ payload: { assignment: offer.assignment } }));
    }
    this.modalRef = this.modalService.open(
      {
        hideHeader: true,
        bodyTemplate: this.offerInfoPopup,
        hideFooter: true,
      },
      {
        backdrop: 'static',
        size: 'xl',
      }
    );

    this.modalRef.result.then(noop, noop);
  }

  openRequirementsModal(event: Event, profile: CustomerInquiryOfferProfileListItemResponse): void {
    event.stopPropagation();
    this.offerProfileRequirements = this.baseInquiryService.ungroupRequirements(profile.requirements);
    this.modalRef = this.modalService.open(
      {
        headText: !!this.inquiry.requirements?.length ? 'inquiry.requirementsFor' : 'inquiry.noRequirementsSet',
        headTextTranslateParams: { fullName: `${profile.firstName} ${profile.lastName}` },
        headerSize: BaseModalHeaderSizes.sm,
        bodyTemplate: this.requirementsPopup,
        okText: 'action.close',
        cancelButtonDisplayed: false,
        cancelButtonOnly: true,
      },
      {
        scrollable: false,
        backdrop: 'static',
        size: 'lg',
      }
    );

    this.modalRef.result.then(noop, noop);
  }

  allRequirementsFulfilled(
    offerProfileRequirements: RequirementCategoryResponse[],
    inquiryRequirements: RequirementCategoryResponse[]
  ): boolean {
    return this.baseInquiryService
      .ungroupRequirements(inquiryRequirements)
      .every((inquiryRequirement) =>
        this.baseInquiryService
          .ungroupRequirements(offerProfileRequirements)
          .some((profileRequirement) => profileRequirement.id === inquiryRequirement.id)
      );
  }

  copyInquiry(inquiry: InquiryResponse) {
    const copiedInquiry = { ...inquiry, id: undefined };
    const isMixedShifts = this.baseCustomerInquiryService.defineIsShiftTypesMixed(copiedInquiry);

    if (isMixedShifts) {
      this.baseCustomerInquiryService.openShiftViewPage(copiedInquiry);
    } else {
      this.openNewStaffRequestModal();
    }
  }

  openIndustrySurchargeModal(event: Event, surcharges: IndustrySurchargeResponse): void {
    event.stopPropagation();
    if (!surcharges) {
      return;
    }

    this.clickedIndustrySurchargeIndex = this.offers.findIndex((item) => surcharges === item.data.industrySurcharges);
    this.modalService.open(
      {
        headText: 'industrySurcharges.plural',
        bodyTemplate: this.industrySurchargesModal,
        cancelButtonDisplayed: true,
        okButtonDisplayed: false,
      },
      {
        scrollable: false,
        backdrop: 'static',
        size: 'lg',
      }
    );
  }

  openNewStaffRequestModal(): void {
    this.modalRef = this.modalService.open(
      {
        headText: 'inquiry.new',
        bodyTemplate: this.staffRequest,
        hideFooter: true,
      },
      {
        backdrop: 'static',
        size: 'lg',
      }
    );

    this.modalRef.result.then(() => {
      this.isSidebarVisible = false;
    }, noop);
  }

  onPublish(): void {
    const modalRef = this.modalService.open(
      {
        headText: 'inquiry.publishInquiryNow',
        bodyText: 'inquiry.publishInquiryConfirmText',
        okText: 'action.yesPublish',
        cancelButtonBackground: 'secondary',
        cancelButtonDisplayed: true,
      },
      {
        scrollable: false,
        backdrop: true,
        size: 'md',
      }
    );

    modalRef.result.then(() => {
      this.updateCustomerInquiryStatus(BaseInquiryStatus.published);
    }, noop);
  }

  onClose(): void {
    this.onInquiryCloseModalRef = this.modalService.open(
      {
        headText: 'inquiry.closeInquiry.headText',
        bodyTemplate: this.closeInquiryModal,
        hideFooter: true,
      },
      {
        scrollable: false,
        backdrop: true,
        size: 'lg',
      }
    );

    this.onInquiryCloseModalRef.result.then((value: string) => {
      this.updateCustomerInquiryStatus(BaseInquiryStatus.closed, value);
    }, noop);
  }

  handleClick(actionType: string) {
    switch (actionType) {
      case 'action.edit':
        this.onEdit();
        break;
      case 'action.close':
        this.onClose();
        break;
      case 'action.publish':
        this.onPublish();
        break;
    }
  }

  getInquiryActiveFilters(): void {
    this.store
      .select(baseInquirySelectors.getCustomerSelectedFilters)
      .pipe(
        takeUntil(this.destroy$),
        map((state) => state.data)
      )
      .subscribe((data) => {
        if (data) {
          this.inquiryListActiveFilters = { ...data.filters };

          for (let i in this.inquiryListActiveFilters) {
            this.inquiryListActiveFilters[i] = this.inquiryListActiveFilters[i].toString();
          }
        }
      });
  }

  onScrollDown(): void {
    if (this.pagination && this.pagination.page.current < this.pagination.page.total) {
      this.store.dispatch(
        baseInquiryActions.loadCustomerInquiryOffersList({
          payload: {
            ...this.activatedRoute.snapshot.queryParams,
            experience: BaseHelpersService.stringToBoolean(this.activatedRoute.snapshot.queryParams.experience),
            inquiry: this.inquiry.id as number,
            loadNextPage: true,
            page: this.pagination.page.current + InquiryOffersPagination.page,
          },
        })
      );
    }
  }

  private initFilterValuesByQueryParams(): void {
    const filtersValues = this.filterService.setInitialFilterValuesByQueryParams(
      this.filtersForm.value,
      {
        [BaseInquiryOffersFilters.mainQualifications]: this.filterService.convertArrayToKeyValueObject(
          this.mainQualifications,
          'id',
          'name'
        ),
        [BaseInquiryOffersFilters.pspBranches]: this.filterService.convertArrayToKeyValueObject(
          this.branches,
          'id',
          'name'
        ),
        [BaseInquiryOffersFilters.rating]: this.queryParamsService.getQueryParam('rating'),
        [BaseInquiryOffersFilters.experience]: this.filterService.convertArrayToKeyValueObject(
          this.baseInquiryExperienceOption,
          'value',
          'label'
        ),
        [BaseInquiryOffersFilters.workCouncilStatus]: this.filterService.convertArrayToKeyValueObject(
          this.baseCustomerWCApprovalOptions,
          'value',
          'name'
        ),
      },
      ['rating', 'search']
    );
    this.hasFiltersValues = this.filterService.hasFilterValues(this.filtersForm.value);

    if (!this.hasFiltersValues) {
      return;
    }
    const statusValue = this.queryParamsService.getQueryParam('status');
    this.filtersForm.patchValue({
      ...filtersValues,
      experience: filtersValues.experience
        ? {
            value: JSON.parse(filtersValues.experience[0].value as string),
            label: filtersValues.experience[0].name,
          }
        : undefined,
      status: filtersValues.status
        ? this.baseOfferStatusOption.find((item) => item.id === parseInt(statusValue))
        : undefined,
    });
  }

  private fetchFilteredInquiries() {
    this.queryParamsService.filterSubject.pipe(takeUntil(this.destroy$), debounceTime(50)).subscribe((value) => {
      this.queryParamsService.redirectWithQueryParams(
        {
          ...value,
          filters: {
            ...value?.filters,
            experience: value?.filters?.experience?.value?.toString(),
            status: value?.filters?.status?.id?.toString(),
            workCouncilStatus: value?.filters?.workCouncilStatus?.value?.toString(),
          },
        },
        { search: 'value' },
        () => this.loadInquiryOffers()
      );
    });
  }

  private loadInquiryOffers(): void {
    const queryParams = this.activatedRoute.snapshot.queryParams;

    const payload = {
      ...queryParams,
      inquiry: this.copiedInquiry.id as number,
      profileAverageRating: queryParams.rating ? parseInt(queryParams.rating, 10) : undefined,
      experience: BaseHelpersService.stringToBoolean(queryParams.experience),
    };
    this.store.dispatch(
      baseInquiryActions.loadCustomerInquiryOffersList({
        payload: payload,
      })
    );
  }

  private updateCustomerInquiryStatus(status: 1 | 2 | 3, closedNote?: string): void {
    this.isSidebarVisible = false;
    this.store.dispatch(
      baseInquiryActions.updateInquiryStatus({
        payload: { inquiry: this.copiedInquiry.id as number, status, closedNote },
      })
    );
    this.router.navigate(['inquiries/list'], {
      queryParams: { status: `${BaseInquiryStatus.unpublished},${BaseInquiryStatus.published}` },
    });
  }

  openNoteFromProviderModal(event: Event, offer: CustomerOfferListItemResponse): void {
    event.stopPropagation();
    if (offer.note) {
      this.modalRef = this.modalService.open(
        {
          headText: 'inquiry.noteFromProvider',
          bodyText: offer.note,
          okText: 'action.close',
          cancelButtonDisplayed: false,
          cancelButtonOnly: true,
        },
        {
          scrollable: false,
          backdrop: 'static',
          size: 'lg',
        }
      );

      this.modalRef.result.then(noop, noop);
    }
  }

  openPositionsDatePickerModal(event: Event, offer: CustomerInquiryOfferListItemResponse): void {
    this.currentOfferInfo = offer;
    event.stopPropagation();
    if (offer.positions) {
      this.modalRef = this.modalService.open(
        {
          headText: 'inquiry.offeredDays',
          bodyTemplate: this.datePickerModal,
          okText: 'action.close',
          cancelButtonDisplayed: false,
          cancelButtonOnly: true,
        },
        {
          scrollable: false,
          backdrop: 'static',
          size: 'md',
        }
      );

      this.modalRef.result.then(noop, noop);
    }
  }

  openIzsInfoModal(event: Event, pspBranch: OfferPspBranchShortInfoResponse): void {
    event.stopPropagation();
    this.router.navigate(['/service-provider'], {
      queryParams: {
        page: 1,
        search: pspBranch.name,
        pspBranchId: pspBranch.id,
        location: this.inquiry.customerLocation?.id,
      },
    });
  }

  private onEdit() {
    const inquiryId = this.copiedInquiry.id as number;

    this.baseCustomerInquiryService.getInquiry(inquiryId).subscribe((inquiry) => {
      this.baseCustomerInquiryService.openShiftViewPage(inquiry, inquiryId);
    });
  }
}
